import VueMask from 'v-mask';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(VueMask);
});